export function ErrorUpIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 1.33301C4.32065 1.33301 1.33398 4.31967 1.33398 7.99967C1.33398 11.6797 4.32065 14.6663 8.00065 14.6663C11.6807 14.6663 14.6673 11.6797 14.6673 7.99967C14.6673 4.31967 11.6807 1.33301 8.00065 1.33301ZM10.354 8.01967C10.254 8.11967 10.1273 8.16634 10.0007 8.16634C9.87398 8.16634 9.74732 8.11967 9.64732 8.01967L8.50065 6.87301V10.333C8.50065 10.6063 8.27398 10.833 8.00065 10.833C7.72732 10.833 7.50065 10.6063 7.50065 10.333V6.87301L6.35398 8.01967C6.16065 8.21301 5.84065 8.21301 5.64732 8.01967C5.45398 7.82634 5.45398 7.50634 5.64732 7.31301L7.64732 5.31301C7.84065 5.11967 8.16065 5.11967 8.35398 5.31301L10.354 7.31301C10.5473 7.50634 10.5473 7.82634 10.354 8.01967Z"
        fill="currentColor"
      />
    </svg>
  );
}
